

(() => {
	/* ============================================================
	   ВИПРАВЛЕНО 25 серп. 2026 — примусове перекомпонування

	   Було: усі каруселі товарів ініціалізувались одразу при
	   завантаженні, навіть ті, що лежать поза першим екраном
	   (на головній карусель починається з 1111-го пікселя).
	   Ініціалізація Swiper читає геометрію одразу після того,
	   як її змінила, і змушує браузер синхронно перераховувати
	   розкладку. У звіті це п'ять із десяти позицій forced reflow,
	   разом 739 мс на десктопі.

	   Стало: карусель ініціалізується через IntersectionObserver
	   за 600px до входу у видиму зону. Робота нікуди не зникає,
	   але виходить з вікна завантаження, де вона псує TBT і INP.

	   Захист від збою: якщо IntersectionObserver недоступний —
	   ініціалізуємо одразу, як було. Плюс страховка на 6 секунд,
	   щоб карусель гарантовано ожила навіть при дивній поведінці
	   спостерігача.

	   ЯКЩО КАРУСЕЛЬ ПЕРЕСТАЛА ГОРТАТИСЬ — замініть виклик
	   observeCarousels() наприкінці файлу на initAll().
	   ============================================================ */

	const SELECTOR = ".product-carousel-section";
	const ROOT_MARGIN = "600px";
	const FALLBACK_MS = 6000;

	let observer = null;
	let fallbackTimer = null;

	/* ============================================================
	   ЗМІНА 08.09.2026 — відкладені слайди каруселі.

	   Слайди після (product_limit + 1) віддаються в <template>
	   всередині ПОРОЖНЬОЇ .swiper-slide. Оболонка лишається в DOM,
	   тому Swiper з першої секунди бачить усі слайди: slidesPerView,
	   ширини й стан стрілок правильні одразу, swiper.update() не
	   потрібен ніде.

	   Гідратація — на першу взаємодію з каруселлю, один раз, усі
	   відкладені слайди разом. Навмисно НЕ в такті new Swiper:
	   ініціалізація і вставка вузлів не падають в один кадр.

	   ЯКЩО СЛАЙДИ ПІСЛЯ ШОСТОГО ЛИШИЛИСЬ ПОРОЖНІМИ — викличте
	   hydrateSection(section) одразу після new Swiper.
	   ============================================================ */

	const DEFERRED = ".swiper-slide[data-slide-deferred]";

	const hydrateSection = (section) => {
		const pending = section.querySelectorAll(DEFERRED);
		if (!pending.length) return;

		pending.forEach((slide) => {
			slide.removeAttribute("data-slide-deferred");
			const tpl = slide.querySelector("template[data-slide-content]");
			if (!tpl) return;
			slide.appendChild(document.importNode(tpl.content, true));
			tpl.remove();
			const stub = slide.querySelector("[data-slide-stub]");
			if (stub) stub.remove();
		});

		if (typeof window.changeSwatchesImage === "function") {
			window.changeSwatchesImage();
		}
	};

	const bindHydration = (section, swiper) => {
		if (!section.querySelector(DEFERRED)) return;

		const run = () => hydrateSection(section);

		section.addEventListener("pointerdown", run, { passive: true, once: true });
		section
			.querySelectorAll(".swiper-button-next, .swiper-button-prev")
			.forEach((btn) =>
				btn.addEventListener("pointerenter", run, { passive: true, once: true })
			);
		if (swiper) {
			swiper.on("touchStart", run);
			swiper.on("slideChange", run);
		}
	};


	const initOne = (section) => {
		const $section = $(section);

		if ($section.hasClass("slider_started")) return;
		$section.addClass("slider_started");

		const id = $section.attr("id");
		const slideEl = $section.find(".swiper-wrapper");
		const productCount = parseInt(slideEl.data("count"));
		const productCountMobile = parseInt(slideEl.data("count-mobile"));

		/* Було: слухач resize на 60 рядків if-else, який виставляв
		   this.params.slidesPerView і НЕ викликав update(), тобто
		   перераховував намарно. Замінено на вбудовані breakpoints —
		   Swiper застосовує їх сам, без слухача й без зайвих
		   вимірювань. Пороги й значення збережено один в один. */
		const breakpoints = {};

		if (productCount >= 2) {
			breakpoints[0] = { slidesPerView: productCountMobile || 1 };
			breakpoints[576] = { slidesPerView: Math.min(2, productCount) };
		}
		if (productCount >= 3) {
			breakpoints[750] = { slidesPerView: Math.min(3, productCount) };
		}
		if (productCount >= 4) {
			breakpoints[1100] = { slidesPerView: Math.min(4, productCount) };
		}
		if (productCount >= 5) {
			breakpoints[1360] = { slidesPerView: Math.min(5, productCount) };
		}
		if (productCount >= 6) {
			breakpoints[1600] = { slidesPerView: 6 };
		}

		const swiper = new Swiper(`#${id} .product-carousel-swiper`, {
			loop: false,
			autoHeight: false,
			allowTouchMove: true,
			slidesPerView: productCount,
			spaceBetween: 24,
			breakpoints: breakpoints,
			navigation: {
				nextEl: `#${id} .swiper-button-next`,
				prevEl: `#${id} .swiper-button-prev`,
			},
		});

		bindHydration(section, swiper);
	};

	const initAll = () => {
		document.querySelectorAll(SELECTOR).forEach(initOne);
	};

	const observeCarousels = () => {
		if (typeof Swiper === "undefined") return;

		const sections = document.querySelectorAll(SELECTOR);
		if (!sections.length) return;

		if (!("IntersectionObserver" in window)) {
			initAll();
			return;
		}

		if (!observer) {
			observer = new IntersectionObserver(
				(entries) => {
					entries.forEach((entry) => {
						if (!entry.isIntersecting) return;
						initOne(entry.target);
						observer.unobserve(entry.target);
					});
				},
				{ rootMargin: ROOT_MARGIN }
			);
		}

		sections.forEach((section) => {
			if (!section.classList.contains("slider_started")) {
				observer.observe(section);
			}
		});

		if (fallbackTimer) clearTimeout(fallbackTimer);
		fallbackTimer = setTimeout(initAll, FALLBACK_MS);
	};

	observeCarousels();

	document.addEventListener("shopify:section:load", observeCarousels);
})();